// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import DisplayImage from "./image.png";

const description =
  "A gallery style widget for presenting short profiles of a group of people or events. The extended version has multiple layout styles and labelling options.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "People gallery extended",
  id: "people-gallery-extended",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/people-gallery-extended/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "PeopleGalleryConfigTool" */ "app/components/tools/PeopleGalleryExtendedConfigTool/PeopleGalleryExtendedConfigTool"),
    loading: DynamicImportLoader,
    modules: ["PeopleGalleryExtendedConfigTool"]
  })
};

export default CONFIG;
